import type { HelpFile } from '../../types/help'
import { ResultTableTestIds } from '../../../testids/ResultTableTestIds'

export const resultTableHelp: HelpFile = {
  docPage: '/docs/reporting/results',
  texts: {
    [ResultTableTestIds.resultTable]:
      'Tabellarische Ergebnisse der Reportabfrage.',
    [ResultTableTestIds.btnExportCsv]:
      'Aktuelle Ergebnismenge als CSV-Datei herunterladen.',
    [ResultTableTestIds.btnExportXlsx]:
      'Aktuelle Ergebnismenge als Excel-Datei (XLSX) herunterladen.',
  },
}
